<script>
  import { twMerge } from 'tailwind-merge';
  import { getFullDateAndTime } from '../../../utils/date';

  let { data = [] } = $props();
</script>

<div class="flex flex-col gap-2">
  {#each data as transcription}
    <div
      class={twMerge(
        'w-3/4 self-start rounded-sm bg-gray-7 p-3 text-sm',
        transcription.isNurse && 'self-end bg-gray-8',
      )}
    >
      <div class="flex w-full flex-row justify-between">
        <div class="max-w-32 truncate">
          {#if transcription.isNurse}
            <span class="font-bold italic text-purple-300">Sjuksköterska</span>
          {:else}
            <span class="font-bold italic text-yellow-300">Patient</span>
          {/if}
        </div>
        <div class="truncate">
          {getFullDateAndTime(transcription.timestamp)}
        </div>
      </div>
      <div class="mt-1 text-white">{transcription.text}</div>
    </div>
  {/each}
</div>
